import padding from "../global/padding";
var addBottomPadding = function (props) {
    if (props.large) {
        return "padding-bottom: " + padding.large + ";";
    }
    else if (props.medium) {
        return "padding-bottom: " + padding.medium + ";";
    }
    else if (props.base) {
        return "padding-bottom: " + padding.base + ";";
    }
    else if (props.small) {
        return "padding-bottom: " + padding.small + ";";
    }
    else if (props.tiny) {
        return "padding-bottom: " + padding.tiny + ";";
    }
    else if (props.withBody) {
        return "padding-bottom: 5px;";
    }
    return null;
};
export default addBottomPadding;
